import { checkPhoneAvailability as checkPhoneAvailabilityRequest } from "@vetty/api-sdk";
import { axiosInstance } from "@/helpers";

export const checkPhoneAvailability = async (phone: string) => {
  try {
    const { data } = await checkPhoneAvailabilityRequest(axiosInstance, {
      phone,
    });

    console.log(data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
